// Presentation only: forward selections through Shopify's existing native picker.
// No independent variant, price, cart, URL or media implementation.
if (!customElements.get('pp-digital-format-picker')) {
  customElements.define('pp-digital-format-picker', class extends HTMLElement {
    connectedCallback() {
      this.life?.abort();
      this.life = new AbortController();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true, signal: this.life.signal });
      } else {
        this.init();
      }
    }

    init() {
      const { signal } = this.life;
      this.ui = this.querySelector('[data-digital-format-ui]');
      this.trigger = this.querySelector('[data-digital-format-trigger]');
      this.panel = this.querySelector('[data-digital-format-panel]');
      this.options = [...this.querySelectorAll('[data-digital-format-value]')];
      this.removeAttribute('data-enhanced');
      if (this.ui) this.ui.hidden = true;
      if (!this.ui || !this.trigger || !this.panel || this.dataset.productId !== '15811444703566' || !this.sync()) return;
      this.trigger.addEventListener('click', () => this.toggle(this.panel.hidden), { signal });
      this.options.forEach(option => option.addEventListener('click', () => {
        this.choose(option);
        this.toggle(false);
        this.trigger.focus({ preventScroll: true });
      }, { signal }));
      this.ui.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !this.panel.hidden) {
          event.preventDefault(); event.stopPropagation();
          this.toggle(false); this.trigger.focus({ preventScroll: true });
          return;
        }
        const index = this.options.indexOf(event.target.closest('[data-digital-format-value]'));
        if (index < 0 || event.altKey || event.ctrlKey || event.metaKey) return;
        const count = this.options.length;
        const next = { ArrowRight: (index + 1) % count, ArrowDown: (index + 1) % count,
          ArrowLeft: (index + count - 1) % count, ArrowUp: (index + count - 1) % count,
          Home: 0, End: count - 1 }[event.key];
        if (next === undefined) return;
        event.preventDefault();
        this.choose(this.options[next]);
        this.options[next].focus({ preventScroll: true });
      }, { signal });
      this.addEventListener('change', event => {
        if (event.target.closest('variant-picker')) this.sync();
      }, { signal });
      this.addEventListener('variant:update', () => this.sync(), { signal });
      window.addEventListener('pageshow', () => this.sync(), { signal });
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) this.toggle(false);
      }, { signal });
      this.addEventListener('focusout', event => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.toggle(false);
      }, { signal });
      this.toggle(false);
    }

    controls() {
      const native = this.querySelector('variant-picker');
      if (native?.dataset.productId !== this.dataset.productId || native.querySelectorAll('.variant-option').length !== 1) return null;
      const select = native.querySelector('select');
      const radios = [...native.querySelectorAll('input[type="radio"]')];
      const inputs = select ? [...select.options] : radios;
      // Future additional formats/combined listings keep the native fallback.
      if (inputs.length !== 3 || this.options.length !== 3 || inputs.some(input =>
        input.dataset.connectedProductUrl && input.dataset.connectedProductUrl !== native.dataset.productUrl)) return null;
      if (this.options.some(option => !option.querySelector('svg')?.children.length ||
        inputs.filter(input => input.value === option.dataset.digitalFormatValue).length !== 1)) return null;
      return { select, radios, inputs };
    }

    sync() {
      const controls = this.controls();
      const value = controls?.select?.value || controls?.radios.find(input => input.checked)?.value;
      this.selected = this.options.find(option => option.dataset.digitalFormatValue === value);
      if (!controls || !this.selected) {
        this.removeAttribute('data-enhanced');
        this.ui.hidden = true;
        this.toggle(false);
        return false;
      }
      this.options.forEach(option => {
        const selected = option === this.selected;
        option.setAttribute('aria-checked', String(selected));
        option.tabIndex = selected ? 0 : -1;
      });
      const name = this.selected.dataset.digitalFormatName;
      this.querySelector('[data-digital-format-current-name]').textContent = name;
      this.querySelector('[data-digital-format-current-icon]').replaceChildren(this.selected.querySelector('svg').cloneNode(true));
      const input = controls.inputs.find(input => input.value === value);
      const unavailable = input.getAttribute('aria-disabled') === 'true' || input.dataset.optionAvailable === 'false';
      this.querySelector('[data-digital-format-status]').textContent = name + ' ausgewählt' + (unavailable ? ' · aktuell nicht verfügbar' : '');
      this.ui.hidden = false;
      this.setAttribute('data-enhanced', '');
      return true;
    }

    choose(option) {
      const controls = this.controls();
      if (!controls) { this.sync(); return; }
      const target = controls.select || controls.radios.find(input => input.value === option.dataset.digitalFormatValue);
      if (!target) return;
      const previous = controls.select?.value || controls.radios.find(input => input.checked)?.value;
      if (previous === option.dataset.digitalFormatValue) return;
      if (controls.select) target.value = option.dataset.digitalFormatValue;
      else target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }

    toggle(open) {
      if (!this.panel || !this.trigger) return;
      this.panel.hidden = !open;
      this.toggleAttribute('data-picker-open', open);
      this.trigger.setAttribute('aria-expanded', String(open));
      if (open) this.selected?.focus({ preventScroll: true });
    }

    disconnectedCallback() { this.life?.abort(); }
  });
}
